export const TranslationShortLocaleException = ["zh-CN", "zh-TW"];
